export default {
    Get: {
        KANBAN_URL: 'getKanbanUrl',
    },
    Set: {
        KANBAN_URL: 'setKanbanUrl',
    }
};